export default [
    {
        path: '/catalogo-grade',
        name: 'catalogo-grade-index',
        component: () => import('./views/Index.vue'),
        meta: {
            title: 'Catálogo de Oferta',
            icon: 'mdi-table-large',
            breadcrumbs: [
                { text: 'Catálogo de Oferta', disabled: true, href: '/' }
            ]
        }
    }
]
